import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { SCENE_VIEW_ID } from '../../constants';

class Portal extends React.Component {
  //
  // PropTypes

  static propTypes = {
    children: PropTypes.node.isRequired,
    container: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Element),
    ]),
  };

  _getContainer() {
    const container = this.props.container;

    if (typeof container === 'string') {
      return (
        document.querySelector(container) ||
        document.querySelector(`#${SCENE_VIEW_ID}`) ||
        document.body
      );
    }

    if (container instanceof Element) {
      return container;
    }

    return document.querySelector(`#${SCENE_VIEW_ID}`) || document.body;
  }

  //
  // Render
  render() {
    return createPortal(this.props.children, this._getContainer());
  }
}

export default Portal;
